import { useState, useEffect, useMemo } from 'react';

import api from '../../apis';
import moment from 'moment';
import { usePagination } from './helper';

import ReactTable from '../general/form-control/react-table';
import { useFilter } from '../../context/FilterContext';
import { numberWithCommas } from '../general/convertor';
import { Button } from 'antd';

const PurchaseSalesTbl = ({
    //accounts = []
    inputs={},
    settlementType = null,
    statementType
    
}:any) => {
    const { tablePagination, setTablePagination } = usePagination();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [_inputs, _setInputs] = useState({});
    const [summary, setSummary] = useState(null);
    

    const { filterParams,setFilterParams } = useFilter();
    useEffect(() => {
        handleFilter(filterParams)
    }, [filterParams]);



    const handleFilter = (filterParams:any)=>{
        if(Object.keys(filterParams).length == 0) return;

        let accounts = filterParams["accounts[]"] ||[];
        requestTableData(accounts,1,filterParams);
     
        _setInputs(filterParams);
        setAccounts(accounts);

 
    }
 

    const requestTableData = async (accounts:string[],cPage=1,inputs:any={}) =>{
        if(accounts.length <1) {
            setTableData([])
            return 
        }

       // if(!orderNo)return;
        setLoading(true)

        let year = filterParams.year;
        if(!year){
            const currentYear = moment().year();
            filterParams.year = currentYear;
        }

        let type = statementType;
        filterParams.type = type;
   
        api.getEstatementList(accounts[0], filterParams).then(
            (result: any) => {
                setLoading(false);
                //console.log('result', result);
                if (result) {
                   setTableData(result)
                }
            }
        );

        
       //setLoading(false)
        // console.log("getTradeHistoryLogs",result)
    }


    const tblColumns = useMemo(
        () => [
            {
                Header: 'Items No.',
                accessor: 'order',
                Cell: (v: any) => {
                    let index = v.cell.row.index;
                    return <>{index+1}</>
                }
            },
            {
                Header: 'Details',
                accessor: 'es_date',
                Cell: (v: any) => {
                    if (v.value) return moment(v.value).format('DD-MM-YYYY');
                }
            },
            {
                Header: '',
                accessor: 'month',
                Cell: ({ row }:any) => {
                    let rowData = row?.original;
                    let es_filepath = rowData.es_filepath;
                    let es_date = rowData.es_date;
                    let currentAccNo = accounts[0];

                    let es_aid = rowData.es_aid;
                    let es_id = rowData.es_id;

                    let url = `./client/account/${es_aid}/estatement/${es_id}/file`
                    // http://portal.finext.com/client/account/507/estatement/74/file

                    // console.log(row?.original)
                    return (
                        <a
                            href=""
                            onClick={(e) => {
                                e.preventDefault();
                                return window.open(
                                    './file/estatement/' + es_aid + '/' + es_id,
                                    '_blank',
                                    'noopener,noreferrer'
                                );
                            }}
                        >
                            {/* {es_date} */}
                            {/* {moment(es_date).format('MMM YYYY')} */}
                            PDF
                    </a>
                    );
                }
                
             
            },
          
       
        ],
        []
    );

    const handleOpenFile = (row:any) => {
        //console.log('row',row)
        let file_path = row.ctrt_filepath;
        //let a_code = row.a_code;
        let accounts = filterParams["accounts[]"] ||[];
        let url = `/api/client/account/${accounts}/file/${file_path}`;
        window.open(url, '_blank');
    }


    return (
        <>
            <ReactTable
                // headerStyle={{
                //     background: 'rgba(210, 209, 209, 1)',
                //     color:"black"
                // }}
                columns={tblColumns}
                data={tableData}
                loading={loading}
                size='small'
                borderSeparate={true}
                // pageSize={10}
                // currentPage={tablePagination.currentPage}
                // totalRecords={tablePagination.totalRecords}
                // pageChange={(cPage: number) => {
                //     // showNotiLoader();
                //     requestTableData(accounts, cPage,inputs);
                // }}
                // hasPagination
                
            />
  
        </>
    );
};

export default PurchaseSalesTbl;
